module.exports = __webpack_public_path__ + "img/copyright.cc432684.png";